import getState, { createPromise, dynamicSort, isDev } from "../utils/MainHelper.js";
import MainServices from "./Main.services";
import SAscore from "../config/SA.score.json";
import { getCountryCode, getModuleCode, getPackage } from "../utils/oneintelligence/OneIntelligenceHelper.js";
import { read, utils } from "xlsx";
import WorkerServices from "./Worker.services.js";
import explorerList from "../config/MarketExplorer.config.json"

class ConfigServices {
  constructor() {
    this.configPath = "oneintel/config/"
    this.treeConfigPath = "oneintel/treePermission/"
    this.savantCheckerPath = "oneintel/savantcheck/"
    this.marketExplorerListTemp = null;
    this.appConfig = null;
    this.analysisListTemp = [];
    this.analysisObjectListTemp = {};
    this.cachedUserTreePermission = {};
    this.cachedTreeConfig = {};
    this.defaultSelections = {};
    this.analysisDetailsTemp = {};
    this.lockFolderConfigCache = {};
    this.brandListToFilter = []
    // whitespace
    this.whitespaceConfig = null;
    this.whitespaceTranslation = null;
    this.whitespaceOverAllPieConfig = null;

    this._adminUsers = []
    this._whiteLabelDictionary = {}
  }

  getSavantCheckerPath(path) {
    return this.savantCheckerPath + path + ".json"
  }
  getConfigPath(path) {
    return this.configPath + path + ".json"
  }

  getTreeConfigPath(path) {
    return this.treeConfigPath + path + ".json"
  }

  loadApplicationConfig() {
    return MainServices.getFile(this.getConfigPath("configuration"))
      .then((resp) => {
        this.appConfig = resp || {};
        return this.appConfig
      })
  }

  loadMarketExplorerListConfig(forcePath) {
    // this.marketExplorerListTemp = explorerList;
    // return Promise.resolve(explorerList)
    const isDevVal = isDev();
    let path = forcePath || "marketExplorerListConfig";
    if (!forcePath && isDevVal) {
      path = "marketExplorerListConfigDev";
    }
    const { promise, resolve } = createPromise()
    MainServices.getFile(this.getConfigPath(path)).then((resp) => {
      this.marketExplorerListTemp = resp;
      resolve(resp);
    }).catch(() => {
      this.loadMarketExplorerListConfig(path.replace("Dev", "")).then((res) => {
        this.marketExplorerListTemp = res;
        resolve(res)
      })
    })
    return promise
  };

  // loadAnalysisListConfig(forcePath) {
  //   const isDevVal = isDev();
  //   let path = "analysisListListConfig";
  //   if (isDevVal) {
  //     path = "analysisListListConfigDev";
  //   }
  //   return MainServices.getFile(this.getConfigPath(path))
  //     .then((resp) => {
  //       if (resp) {
  //         this.analysisListTemp = resp;
  //       } else {
  //         if (!forcePath && isDevVal) {
  //           this.loadAnalysisListConfig(path.replace("Dev", ""));
  //         }
  //       }
  //     });
  // };

  loadAnalysisDetails() {
    return MainServices.getFile(this.getConfigPath("analysisDetails"))
      .then((resp) => {
        if (resp) {
          this.analysisDetailsTemp = resp;
        } else {
          this.analysisDetailsTemp = {};
        }
        return Promise.all(Object.keys(this.analysisObjectListTemp).map((id) => {
          const analysisObj = this.analysisObjectListTemp[id]
          return MainServices.getFile(`accountsmanagement/analysis/${id}.json`, "accounts").then((obj) => {
            if (obj) {
              this.analysisDetailsTemp[analysisObj.key] = {
                ...this.analysisDetailsTemp[analysisObj.key],
                ...obj
              }
            }
          })
        })).then(() => {
          this.analysisObjectListTemp = {}
        })
      });
  };

  getUserTreePermission(userName) {
    const account = MainServices.getAccount()
    const usergroupname = MainServices.getUserGroup()
    const path = this.getTreeConfigPath(`${account}/${userName}`)
    const pathUserGroup = this.getTreeConfigPath(`${account}/usergroups/${usergroupname}`)
    if (this.cachedUserTreePermission[path] || this.cachedUserTreePermission[pathUserGroup]) {
      return Promise.resolve({
        ...this.cachedUserTreePermission[path] || {},
        ...this.cachedUserTreePermission[pathUserGroup] || {}
      });
    }
    const prmuser = MainServices.getFile(path).then((resp) => {
      if (resp) {
        this.cachedUserTreePermission[path] = resp
        return resp
      }
      return null
    });
    const prmusergroup = MainServices.getFile(pathUserGroup).then((resp) => {
      if (resp) {
        this.cachedUserTreePermission[pathUserGroup] = resp
        return resp
      }
      return null
    });

    return Promise.all([prmuser, prmusergroup]).then(([user, usergroup]) => ({
      ...user || {},
      ...usergroup || {}
    }));
  }

  getTreePermissionPath() {
    const { username, signedUsergroup: {
      usergroupName
    } } = MainServices.userDetails()
    const [userName] = username.split("@");
    const account = MainServices.getAccount()
    const path = `oneintel/treePermission/${account}/${userName}.json`;
    const pathUserGroup = `oneintel/treePermission/${account}/usergroups/${usergroupName}.json`;
    return {
      user: path,
      usergroup: pathUserGroup,
      userName,
      usergroupName
    }
  }
  getAccountTreeConfig() {
    const account = MainServices.getAccount()
    const path = this.getTreeConfigPath(`${account}/config`);
    if (this.cachedTreeConfig[path]) {
      return Promise.resolve(this.cachedTreeConfig[path] || {});
    }
    return MainServices.getFile(path).then((resp) => {
      if (resp) {
        this.cachedTreeConfig[path] = resp
        return resp
      }
    }).catch(() => {
      return null;
    })
  }

  async loadTreePermission() {
    const { username } = MainServices.userDetails();
    const usergroupname = MainServices.getUserGroup();
    const checkIfHasS3Permission = (obj) => {
      const [userName] = username.split("@");
      if (obj?.users?.includes(userName) || obj?.usergroups?.includes(usergroupname)) {
        return this.getUserTreePermission(userName);
      }
      return Promise.resolve(false);
    };

    let accountTempAttribute = {};
    const config = await this.getAccountTreeConfig();
    if (config) {
      accountTempAttribute = config;
    }

    if (Object.keys(accountTempAttribute).length) {
      try {
        if (accountTempAttribute?.oi) {
          return checkIfHasS3Permission(accountTempAttribute.oi);
        }
      } catch (e) {
        return Promise.resolve();
      }
    }
    return Promise.resolve();
  }

  getMarketExplorerList() {
    // return MarketExplorerListDev
    return this.marketExplorerListTemp;
  }

  getAnalysisList(isDisabled) {
    // return AnalysisListDev
    // return this.analysisListTemp;
    const { analysisObj, setup: {
      marketPackage
    }, } = getState("buildTargets");
    if (!marketPackage) return []
    try {
      const moduleCode = getModuleCode();
      const entCode = getCountryCode("enterprise");
      this.analysisListTemp = Object.values(analysisObj[marketPackage.id].analysis).map((item) => {
        const disabledItem = isDisabled || !item.isAvailable;
        const currentDetails = this.analysisDetailsTemp[item.key] || {}
        let notAvailable = !item.isAvailable;
        let isHide;
        // if (currentDetails.availableInCountry && !notAvailable) {
        //   notAvailable = !currentDetails.availableInCountry.includes(entCode);
        // } 

        if (currentDetails.availableInCountryObj && !notAvailable) {
          if (currentDetails.availableInCountryObj[moduleCode]) {
            notAvailable = !currentDetails.availableInCountryObj[moduleCode].includes(entCode);
          }
        }

        if (currentDetails.availableInCountryObjHide && !notAvailable) {
          if (currentDetails.availableInCountryObjHide[moduleCode]) {
            isHide = currentDetails.availableInCountryObjHide[moduleCode].includes(entCode);
          }
        }

        const itemData = {
          ...item,
          ...currentDetails,
          title: item.name,
          disabledItem: disabledItem || notAvailable,
          notAvailable,
          isHide
        }

        let sequenceNo = itemData.sequenceNo;
        if (itemData?.seqNoObj?.[moduleCode]) {
          sequenceNo = itemData?.seqNoObj?.[moduleCode]
        }
        return {
          ...itemData, sequenceNo
        }
      }).filter((item) => !(item.isHide === true)).sort(dynamicSort("sequenceNo", true))

      return this.analysisListTemp
    } catch (error) {
      return []
    }
  }

  getAnalysisItem(key) {
    if (!this.analysisListTemp.length) {
      this.getAnalysisList()
    }
    return this.analysisListTemp.find((type) => type.key === key)
  }

  getAppConfig() {
    return this.appConfig;
  }

  getCacheTreePermission() {
    const { username } = MainServices.userDetails()
    const account = MainServices.getAccount()
    const usergroupname = MainServices.getUserGroup()

    const [userName] = username.split("@");
    const path = this.getTreeConfigPath(`${account}/${userName}`)
    const pathUserGroup = this.getTreeConfigPath(`${account}/usergroups/${usergroupname}`)
    return {
      ...this.cachedUserTreePermission[path] || {},
      ...this.cachedUserTreePermission[pathUserGroup] || {}
    };
  }

  getDefaultSelectionsCofig(isLoad) {
    if (!isLoad) return this.defaultSelections
    return MainServices.getFile(this.getConfigPath("defaultSelectionsConfig")).then((resp) => {
      return this.defaultSelections = resp;
    })
  }

  getInitialScore(code) {
    if (code === "sa") return Promise.resolve(SAscore)
    return Promise.resolve(null)
    return MainServices.getFile(this.getConfigPath(`initialscore/${code}`))
  }

  getTiktokAudienceSizes() {
    // const moduleCode = getModuleCode()
    // if (["tiktokaudiences"].includes(moduleCode)) {
    //   const entCode = getCountryCode("enterprise")
    //   return MainServices.getFile(`oneintel/modules/${moduleCode}/${entCode}/sizes.xlsx`, undefined, true).then((resp) => {
    //     const workbook = read(resp.Body, {});
    //     const json = utils.sheet_to_json(workbook.Sheets[Object.keys(workbook.Sheets)[0]])
    //     return WorkerServices.setTiktokAudienceSize([json])
    //   })
    // }
    return Promise.resolve()
  }

  getHardCodedSize() {
    const moduleCode = getModuleCode()
    try {
      const OICode = getPackage();
      const entCode = getCountryCode("enterprise")
      return MainServices.getFile(`oneintel/modules/${moduleCode}/${entCode}/sizes.xlsx`, undefined, true).then((resp) => {
        const workbook = read(resp.Body, {});
        const list = utils.sheet_to_json(workbook.Sheets[Object.keys(workbook.Sheets)[0]])

        if (OICode === "whitespaces") {
          return WorkerServices.whitespace("setHardcodedSize", [{ module: moduleCode, country: entCode, list }])
        }
        return WorkerServices.report("setHardcodedSize", [{ module: moduleCode, country: entCode, list }])
      }).catch(() => {
        return Promise.resolve()
      })
    } catch (error) {
      return Promise.resolve()
    }
  }

  getBrandsListToFilter() {
    try {
      return MainServices.getFile(`oneintel/config/brandlist/brand_translation.xlsx`, undefined, true).then((resp) => {
        const workbook = read(resp.Body, {});
        const list = utils.sheet_to_json(workbook.Sheets[Object.keys(workbook.Sheets)[0]]);
        if (list) {
          const listObj = list.reduce((acc, obj) => {
            const { Brand, Brands } = obj
            acc[Brand] = true
            acc[Brands] = true
            return acc
          }, {})
          this.brandListToFilter = Object.keys(listObj);
        }
      }).catch(() => {
        return Promise.resolve()
      })
    } catch (error) {
      return Promise.resolve()
    }
  }

  getWhiteSpaceConfig() {
    if (this.whitespaceConfig) return Promise.resolve(this.whitespaceConfig);
    return MainServices.getFile(this.getConfigPath("whitespaceOverAllPieConfig")).then((resp) => {
      if (resp.exemptedCategory) {
        this.whitespaceConfig = resp;
      }
      return this.whitespaceConfig || {};
    });
  }
  getWhiteSpaceTranslation() {
    if (this.whitespaceTranslation) return Promise.resolve(this.whitespaceTranslation);
    return MainServices.getFile(this.getConfigPath("whitespaceToTranslate")).then((resp) => {
      this.whitespaceTranslation = resp;
      return this.whitespaceTranslation || [];
    });
  }

  getSavantKeyFile(key) {
    return MainServices.getFile(this.getSavantCheckerPath(key))
  }

  getFolderLockPath({ module, marketExplorerCode }) {
    return `oneintelligence/lockfolder/${module}/${marketExplorerCode}/folderLock.json`;
  }

  getFolderLockConfig(params) {
    if (!params.marketExplorerCode && !params.module) return Promise.resolve(null);
    const path = this.getFolderLockPath(params);
    const enterpriseCode = getCountryCode("enterprise");
    if (this.lockFolderConfigCache[path]) {
      const configObj = {
        allcountry: this.lockFolderConfigCache[path].allcountry,
        current: this.lockFolderConfigCache[path][enterpriseCode]
      }
      if (!Object.keys(configObj).length) return Promise.resolve()
      return Promise.resolve(configObj)
    }
    return MainServices.getFile(path).then((resp) => {
      if (resp) {
        this.lockFolderConfigCache[path] = resp;
        const configObj = {
          allcountry: resp.allcountry,
          current: resp[enterpriseCode]
        }
        if (!Object.keys(configObj).length) return
        return configObj
      }
      return
    });
  }

  getAdminUsers() {
    return MainServices.getFile(`${this.configPath}hasCacheAccess.json`).then((resp) => {
      this._adminUsers = resp || []
    });
  }

  getWhiteLabelDictionary() {
    return MainServices.getFile(`${this.configPath}whitelabel/dictionary/${process.env.REACT_APP_WHITELABEL}.json`).then((resp) => {
      this._whiteLabelDictionary[process.env.REACT_APP_WHITELABEL] = resp || {}
    });
  }
}
export default new ConfigServices();
